import React from 'react';
import { Helmet } from 'react-helmet';

const FAQ = () => {
  return (
    <div className="faq page-container">
      <Helmet>
        <title>FAQ | Pintar Pilih Kuliah</title>
        <meta name="description" content="Pertanyaan yang sering diajukan seputar layanan Pintar Pilih Kuliah, beasiswa, dan proses aplikasi kuliah di luar negeri." />
      </Helmet>
      
      <div className="container">
        <h1>Frequently Asked Questions</h1>
        <p>Halaman FAQ akan segera hadir.</p>
      </div>
    </div>
  );
};

export default FAQ;
